"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("mmol/L")
    .precision(2)
    .min(1)
    .max(19)
    .interpretation({ vocab: "ktx", code: "lab_potassium" })
    .tag({ vocab: "snomed", code: "312468003", source: "synonym" })
    .tag({ vocab: "loinc", code: "6298-4", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
